<div
  mat-dialog-title
  class="d-flex justify-content-between align-items-center pt-2"
>
  <div class="prese_heading">
    <h2 class="m-0">Advance payment setting</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content style="padding-bottom: 0px; margin-bottom: 10px">
  <div class="pres_heading">
     <p class="set_heading marpp">
      These settings are for bookings only. Applicable for normal appointments and session bookings.
    </p>
    <div class="jas_ads" *ngIf="shop_status != '2'">
        <div class="manj_sectiom">
          <div class="shop_service_sec">
            <h3>Shop / In-premise service</h3>
          </div>
          <div class="srd_fft">
            <mat-slide-toggle
              [checked]="toShowCheckShop === 1"
              (change)="onToggleChange($event, 1)"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="radio_group" *ngIf="toShowCheckShop === 1">
          <label>Advance amount: </label>
          <br />
          <mat-radio-group [(ngModel)]="shop_advance_type" (change)="changeShopAdvanceType($event)">
            <div class="flex_numer">
              <div class="add_member_section_radio">
                <mat-radio-button [value]="1">Full</mat-radio-button>
              </div>
              <div class="add_member_section_radio">
                <mat-radio-button [value]="2">Percentage</mat-radio-button>
              </div>
              <div class="add_member_section_radio">
                <mat-radio-button [value]="3">Fixed</mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
        </div>
    
        <div
          *ngIf="
            (shop_advance_type == 2 || shop_advance_type == 3) &&
            toShowCheckShop === 1
          "
        >
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{
              shop_advance_type == 2 ? "Percentage amount" : "Fixed amount"
            }}</mat-label>
            <input
              [(ngModel)]="shop_advance_amount"
              matInput
              smDecimalOnly
              type="number"
            />
          </mat-form-field>
        </div>

    </div>


    <div class="jas_ads" *ngIf="home_status != '2'">
        
            <div class="manj_sectiom">
              <div class="shop_service_sec">
                <h3>Home service</h3>
              </div>
              <div class="srd_fft">
                <mat-slide-toggle
                  [checked]="toShowCheckHome === 1"
                  (change)="onToggleChange($event, 0)"
                ></mat-slide-toggle>
              </div>
            </div>
            <div class="radio_group" *ngIf="toShowCheckHome === 1" >
              <label>Advance amount: </label>
              <br />
              <mat-radio-group [(ngModel)]="home_advance_type" (change)="changeHomeAdvanceType($event)">
                <div class="flex_numer">
                  <div class="add_member_section_radio">
                    <mat-radio-button [value]="1">Full</mat-radio-button>
                  </div>
                  <div class="add_member_section_radio">
                    <mat-radio-button [value]="2">Percentage</mat-radio-button>
                  </div>
                  <div class="add_member_section_radio">
                    <mat-radio-button [value]="3">Fixed</mat-radio-button>
                  </div>
                </div>
              </mat-radio-group>
            </div>
        
            <div
              *ngIf="
                (home_advance_type == 2 || home_advance_type == 3) &&
                toShowCheckHome === 1
              "
            >
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{
                  home_advance_type == 2 ? "Percentage amount" : "Fixed amount"
                }}</mat-label>
                <input
                  [(ngModel)]="home_advance_amount"
                  matInput
                  smDecimalOnly
                  type="number"
                />
              </mat-form-field>
            </div>

    </div>

    <div class="jas_ads" *ngIf="virtual_status != '2'">
        <div class="manj_sectiom">
          <div class="shop_service_sec">
            <h3>Virtual service</h3>
          </div>
          <div class="srd_fft">
            <mat-slide-toggle
              [checked]="toShowCheckVirtual === 1"
              (change)="onToggleChange($event, 2)"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="radio_group" *ngIf="toShowCheckVirtual === 1" >
          <label>Advance amount: </label>
          <br />
          <mat-radio-group [(ngModel)]="virtual_advance_type" (change)="changeVirtualAdvanceType($event)">
            <div class="flex_numer">
              <div class="add_member_section_radio">
                <mat-radio-button [value]="1">Full</mat-radio-button>
              </div>
              <div class="add_member_section_radio">
                <mat-radio-button [value]="2">Percentage</mat-radio-button>
              </div>
              <div class="add_member_section_radio">
                <mat-radio-button [value]="3">Fixed</mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
        </div>
    
        <div
          *ngIf="
            (virtual_advance_type == 2 || virtual_advance_type == 3) &&
            toShowCheckVirtual === 1
          "
        >
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{
              virtual_advance_type == 2 ? "Percentage amount" : "Fixed amount"
            }}</mat-label>
            <input
              [(ngModel)]="virtual_advance_amount"
              matInput
              smDecimalOnly
              type="number"
            />
          </mat-form-field>
        </div>

    </div>
    <p class="set_heading">
      Set the advance payment options for your customers. With these specific
      settings ON, your customers going to pay for the service in advance while
      creating a new booking.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-bottom: 0px; padding-bottom: 0px">
  <button mat-button mat-dialog-close>Cancel</button>
  <button (click)="onSave()" mat-flat-button color="accent">Save</button>
</mat-dialog-actions>
